var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Waits for the given method to have resolved (if actively processing).
 */
export function LifecycleAwaiting(awaitedMethodName) {
    return function (target, propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        if (!originalMethod) {
            return descriptor;
        }
        descriptor.value = function (...args) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const promise = (_a = target.awaiting) === null || _a === void 0 ? void 0 : _a[awaitedMethodName];
                if (promise) {
                    yield promise;
                }
                return originalMethod.apply(this, args);
            });
        };
        return descriptor;
    };
}
/**
 * Records the given asynchronous method into the class such that other members may wait for it when invoked.
 *
 * @example
 *
 *  class MyClass {
 *    \@LifecycleAwaitable
 *    async myAsyncMethod() {
 *      await new Promise(resolve => setTimeout(resolve, 1000))
 *      // Async operation has completed.
 *    }
 *
 *    \@LifecycleAwaiting('myAsyncMethod')
 *    myOtherMethod() {
 *      // Properly awaited myAsyncMethod!
 *    }
 *  }
 *
 *  const myClass = new MyClass
 *  myClass.myAsyncMethod()
 *  myClass.myOtherMethod()
 *
 * ## Output:
 *
 *  > "[myAsyncMethod] Async operation has completed."
 *  > "[myOtherMethod] Properly awaited myAsyncMethod!"
 */
export function LifecycleAwaitable(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    if (!originalMethod) {
        return descriptor;
    }
    descriptor.value = function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = originalMethod.apply(this, args);
            if (!target.awaiting) {
                target.awaiting = {};
            }
            target.awaiting[propertyKey] = result;
            return result;
        });
    };
    return descriptor;
}
